export const CoinBackground = () => {
  return (
    <svg width="288" height="100" viewBox="0 0 180 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.2" filter="url(#filter0_f_8503_2735)">
        <path d="M65.2494 21.696L69.0537 56.656H61.4452L65.2494 21.696Z" fill="white" />
        <path d="M65.2496 91.6152L69.0539 56.6553H61.4453L65.2496 91.6152Z" fill="white" />
        <path d="M85.75 56.6574L65.25 60.4617L65.25 52.8532L85.75 56.6574Z" fill="white" />
        <path d="M44.75 56.6574L65.25 60.4617L65.25 52.8532L44.75 56.6574Z" fill="white" />
      </g>
      <g opacity="0.6" filter="url(#filter1_f_8503_2735)">
        <path
          d="M158.613 80.0449C158.613 107.132 127.905 129.09 90.0251 129.09C52.1452 129.09 21.4375 107.132 21.4375 80.0449C21.4375 52.9582 52.1452 31 90.0251 31C127.905 31 158.613 52.9582 158.613 80.0449Z"
          fill="url(#paint0_linear_8503_2735)"
        />
      </g>
      <g opacity="0.6" filter="url(#filter2_f_8503_2735)">
        <path
          d="M73.8844 29.8845C86.4577 20.7892 102.786 22.2636 109.806 31.9678C113.305 36.8043 113.884 42.8902 111.993 48.9645C110.099 55.0467 105.735 61.0664 99.4535 65.6105C86.8193 74.7497 71.6633 74.1163 64.6785 64.4609C57.6581 54.756 61.3115 38.9797 73.8844 29.8845Z"
          stroke="url(#paint1_linear_8503_2735)"
          stroke-width="2.20844"
        />
        <path
          d="M78.049 34.7232C90.2537 25.8945 106.309 27.5351 113.344 37.2598C120.324 46.9087 115.922 61.5484 103.624 70.4452C91.3584 79.3178 76.4655 78.5235 69.4666 68.8486C62.4313 59.1232 65.8447 43.5517 78.049 34.7232Z"
          stroke="url(#paint2_linear_8503_2735)"
          stroke-width="2.20844"
        />
      </g>
      <path
        d="M78.049 34.7242C90.2537 25.8955 106.309 27.536 113.344 37.2608C120.324 46.9097 115.922 61.5494 103.624 70.4462C91.3584 79.3188 76.4655 78.5245 69.4666 68.8496C62.4313 59.1242 65.8447 43.5527 78.049 34.7242Z"
        stroke="url(#paint3_linear_8503_2735)"
        stroke-width="2.20844"
      />
      <path
        d="M111.295 32.2499C121.479 44.3184 118.849 58.9109 104.682 70.4084C90.0949 81.164 74.2717 78.5693 65.9547 67.9906C57.6378 57.4119 60.6881 39.8272 73.6044 30.4837C86.5207 21.1402 103.633 21.6577 111.295 32.2499Z"
        fill="url(#paint4_linear_8503_2735)"
      />
      <path
        d="M73.8844 29.8855C86.4577 20.7902 102.786 22.2645 109.806 31.9688C113.305 36.8053 113.884 42.8912 111.993 48.9655C110.099 55.0477 105.735 61.0673 99.4535 65.6114C86.8193 74.7507 71.6633 74.1173 64.6785 64.4619C57.6581 54.757 61.3115 38.9807 73.8844 29.8855Z"
        stroke="url(#paint5_linear_8503_2735)"
        stroke-width="2.20844"
      />
      <path
        d="M74.9932 31.5263C87.1063 22.7637 101.199 23.9862 106.986 31.9851C112.772 39.9841 109.522 53.7511 97.4092 62.5136C85.2962 71.276 71.2037 70.0542 65.4172 62.0555C59.6308 54.0566 62.8801 40.2889 74.9932 31.5263Z"
        fill="#FFD93B"
        stroke="url(#paint6_linear_8503_2735)"
        stroke-width="6.13456"
      />
      <path
        d="M76.9705 34.4263C81.9476 30.8259 87.4794 29.0185 92.3847 28.9876C97.2909 28.9568 101.527 30.6981 104.018 34.1412C106.509 37.5845 106.838 42.1536 105.273 46.804C103.709 51.4532 100.261 56.1415 95.2837 59.742C90.3065 63.3425 84.7748 65.1498 79.8694 65.1807C74.9629 65.2116 70.7262 63.4697 68.2353 60.0263C65.7446 56.583 65.4165 52.0146 66.9812 47.3643C68.5456 42.715 71.9933 38.0268 76.9705 34.4263Z"
        stroke="url(#paint7_linear_8503_2735)"
        stroke-width="0.981529"
      />
      <g filter="url(#filter3_d_8503_2735)">
        <g filter="url(#filter4_d_8503_2735)">
          <path
            d="M84.173 42.5275L86.4885 42.4467L85.2812 46.2289L82.9657 46.3098L80.898 52.7172L76.73 52.8627L82.5281 34.8505L89.9122 34.5927L88.6728 38.4268L85.4568 38.5391L84.173 42.5275Z"
            fill="url(#paint8_linear_8503_2735)"
          />
        </g>
        <g filter="url(#filter5_d_8503_2735)">
          <path
            d="M89.1418 50.3654L91.4572 50.2846L90.2499 54.0668L87.9345 54.1477L85.8667 60.5551L81.6987 60.7006L87.4969 42.6884L94.8809 42.4306L93.6416 46.2647L90.4256 46.377L89.1418 50.3654Z"
            fill="url(#paint9_linear_8503_2735)"
          />
        </g>
      </g>
      <g filter="url(#filter6_f_8503_2735)">
        <path
          d="M113.888 45.5291L117.495 51.2778C118.613 44.7092 116.169 39.4517 115.209 37.9932C114.449 36.5684 113.039 34.5671 111.378 32.3711C106.97 25.48 97.6783 19.3339 83.2347 23.9234C66.056 29.8313 60.3618 43.7531 59.751 49.9005L112.42 44.8561L113.888 45.5291Z"
          fill="url(#paint10_linear_8503_2735)"
          fill-opacity="0.3"
        />
      </g>
      <g filter="url(#filter7_f_8503_2735)">
        <path
          d="M113.888 45.5291L117.495 51.2778C118.613 44.7092 116.169 39.4517 115.209 37.9932C114.449 36.5684 113.039 34.5671 111.378 32.3711C106.97 25.48 97.6783 19.3339 83.2347 23.9234C66.056 29.8313 60.3618 43.7531 59.751 49.9005L112.42 44.8561L113.888 45.5291Z"
          fill="url(#paint11_linear_8503_2735)"
          fill-opacity="0.3"
        />
      </g>
      <g opacity="0.4" filter="url(#filter8_f_8503_2735)">
        <path d="M116.861 32.4268L117.882 41.8062H115.84L116.861 32.4268Z" fill="white" />
        <path d="M116.861 51.1855L117.882 41.8061H115.84L116.861 51.1855Z" fill="white" />
        <path d="M122.361 41.8058L116.861 42.8264L116.861 40.7851L122.361 41.8058Z" fill="white" />
        <path d="M111.361 41.8058L116.861 42.8264L116.861 40.7851L111.361 41.8058Z" fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_f_8503_2735"
          x="39.5318"
          y="16.4779"
          width="51.4364"
          height="80.3556"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.60909" result="effect1_foregroundBlur_8503_2735" />
        </filter>
        <filter
          id="filter1_f_8503_2735"
          x="-24.7232"
          y="-15.1607"
          width="229.497"
          height="190.411"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="23.0804" result="effect1_foregroundBlur_8503_2735" />
        </filter>
        <filter
          id="filter2_f_8503_2735"
          x="57.5393"
          y="20.2112"
          width="62.7372"
          height="60.0225"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1.25" result="effect1_foregroundBlur_8503_2735" />
        </filter>
        <filter
          id="filter3_d_8503_2735"
          x="76.73"
          y="34.5928"
          width="18.1509"
          height="26.3533"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.245382" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.937917 0 0 0 0 0.379167 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8503_2735" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8503_2735" result="shape" />
        </filter>
        <filter
          id="filter4_d_8503_2735"
          x="76.6332"
          y="34.5928"
          width="13.3758"
          height="18.4636"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.0967913" />
          <feGaussianBlur stdDeviation="0.0483956" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8503_2735" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8503_2735" result="shape" />
        </filter>
        <filter
          id="filter5_d_8503_2735"
          x="81.6019"
          y="42.4307"
          width="13.3758"
          height="18.4636"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.0967913" />
          <feGaussianBlur stdDeviation="0.0483956" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8503_2735" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8503_2735" result="shape" />
        </filter>
        <filter
          id="filter6_f_8503_2735"
          x="59.3403"
          y="21.9252"
          width="58.8526"
          height="29.7633"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.205345" result="effect1_foregroundBlur_8503_2735" />
        </filter>
        <filter
          id="filter7_f_8503_2735"
          x="55.251"
          y="17.8359"
          width="67.0312"
          height="37.9419"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.25" result="effect1_foregroundBlur_8503_2735" />
        </filter>
        <filter
          id="filter8_f_8503_2735"
          x="109.961"
          y="31.0268"
          width="13.8"
          height="21.5588"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.7" result="effect1_foregroundBlur_8503_2735" />
        </filter>
        <linearGradient
          id="paint0_linear_8503_2735"
          x1="89.6187"
          y1="25.6305"
          x2="89.6187"
          y2="123.72"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.218919" stop-color="#5C5C63" />
          <stop offset="0.504203" stop-color="#212124" />
          <stop offset="0.763116" stop-color="#5C5C63" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8503_2735"
          x1="109.28"
          y1="29.3297"
          x2="70.8221"
          y2="73.0676"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDF8CE" />
          <stop offset="0.0550575" stop-color="#F2E158" />
          <stop offset="0.170676" stop-color="#FCF5AF" />
          <stop offset="0.309086" stop-color="#ECD42F" />
          <stop offset="0.491314" stop-color="#ECC146" />
          <stop offset="0.704021" stop-color="#EFC536" />
          <stop offset="0.78935" stop-color="#E6BC48" />
          <stop offset="0.843399" stop-color="#EFB646" />
          <stop offset="0.909367" stop-color="#E4B130" />
          <stop offset="1" stop-color="#E9C84F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8503_2735"
          x1="112.817"
          y1="34.6219"
          x2="75.0923"
          y2="77.0308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDF8CE" />
          <stop offset="0.0550575" stop-color="#F2E158" />
          <stop offset="0.170676" stop-color="#FCF5AF" />
          <stop offset="0.309086" stop-color="#ECD42F" />
          <stop offset="0.491314" stop-color="#E0B22D" />
          <stop offset="0.704021" stop-color="#F0C127" />
          <stop offset="0.78935" stop-color="#E9D44B" />
          <stop offset="0.843399" stop-color="#E3D156" />
          <stop offset="0.909367" stop-color="#DBC652" />
          <stop offset="1" stop-color="#E0CD66" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_8503_2735"
          x1="112.817"
          y1="34.6228"
          x2="75.0923"
          y2="77.0318"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDF8CE" />
          <stop offset="0.0550575" stop-color="#F2E158" />
          <stop offset="0.170676" stop-color="#FCF5AF" />
          <stop offset="0.309086" stop-color="#ECD42F" />
          <stop offset="0.491314" stop-color="#E0B22D" />
          <stop offset="0.704021" stop-color="#F0C127" />
          <stop offset="0.78935" stop-color="#E9D44B" />
          <stop offset="0.843399" stop-color="#E3D156" />
          <stop offset="0.909367" stop-color="#DBC652" />
          <stop offset="1" stop-color="#E0CD66" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_8503_2735"
          x1="112.169"
          y1="34.899"
          x2="70.4633"
          y2="77.0147"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F6D088" />
          <stop offset="0.0550575" stop-color="#FDEE48" />
          <stop offset="0.170676" stop-color="#EFCF4F" />
          <stop offset="0.309086" stop-color="#D5943D" />
          <stop offset="0.491314" stop-color="#C9813E" />
          <stop offset="0.660555" stop-color="#D5943D" />
          <stop offset="0.771761" stop-color="#EFCF4F" />
          <stop offset="0.815114" stop-color="#EFCF4F" />
          <stop offset="0.881945" stop-color="#E8AE0E" />
          <stop offset="0.930202" stop-color="#D5943D" />
          <stop offset="1" stop-color="#F2C174" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_8503_2735"
          x1="109.28"
          y1="29.3307"
          x2="70.8221"
          y2="73.0686"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDF8CE" />
          <stop offset="0.0550575" stop-color="#F2E158" />
          <stop offset="0.170676" stop-color="#FCF5AF" />
          <stop offset="0.309086" stop-color="#ECD42F" />
          <stop offset="0.491314" stop-color="#ECC146" />
          <stop offset="0.704021" stop-color="#EFC536" />
          <stop offset="0.78935" stop-color="#E6BC48" />
          <stop offset="0.843399" stop-color="#EFB646" />
          <stop offset="0.909367" stop-color="#E4B130" />
          <stop offset="1" stop-color="#E9C84F" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_8503_2735"
          x1="97.0352"
          y1="22.0472"
          x2="78.3298"
          y2="72.0593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFDC5E" />
          <stop offset="0.417119" stop-color="#FFED97" />
          <stop offset="1" stop-color="#FFE77B" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_8503_2735"
          x1="76.9295"
          y1="33.0216"
          x2="97.0667"
          y2="59.6948"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E4991A" />
          <stop offset="0.474971" stop-color="#EAAA2E" stop-opacity="0" />
          <stop offset="1" stop-color="#FFF27B" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_8503_2735"
          x1="84.4192"
          y1="34.7845"
          x2="85.0403"
          y2="52.5725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E19D37" />
          <stop offset="0.494792" stop-color="#EEA230" />
          <stop offset="1" stop-color="#DB9224" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_8503_2735"
          x1="89.3879"
          y1="42.6224"
          x2="90.0091"
          y2="60.4104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E19D37" />
          <stop offset="0.494792" stop-color="#EEA230" />
          <stop offset="1" stop-color="#DB9224" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_8503_2735"
          x1="78.9436"
          y1="47.6369"
          x2="78.1741"
          y2="20.1912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="0.105858" stop-color="white" />
          <stop offset="0.21696" stop-color="white" stop-opacity="0.961194" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_8503_2735"
          x1="78.9436"
          y1="47.6369"
          x2="78.1741"
          y2="20.1912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="0.105858" stop-color="white" />
          <stop offset="0.21696" stop-color="white" stop-opacity="0.961194" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
